import styles from './style.module.scss';
import React from 'react';

const PlanSkeleton: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.sectionHeader}></div>

            <div className={styles.planBox}></div>

            <div className={styles.actions}>
                <div className={styles.button}></div>
                <div className={styles.button}></div>
            </div>
        </div>
    );
};

export default PlanSkeleton;
